/** * * Asynchronously loads the component for
DownloadsHistory
* */ import { lazyLoad } from 'utils/loadable';
export const DownloadsHistory = lazyLoad(() => import('./index'));
